import { css } from "@styled-system/css";

export const headerClass = css({
	display: "flex",
	flexDirection: "row",
});
